module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage5_m.f623f49453fd07139209a0adf4472aff.jpg";